{
  "loading": "Läser in...",
  "loadingMore": "Läser in mer..."
}